import { useQuery } from "@tanstack/react-query";
import api from "../../utils/api";

const fetchRelationship = (eventIdx) => {
	return api("/event-condition/" + eventIdx + "/family-relation").then((data) => data.data);
};

export const useRelationshipQuery = (eventIdx) => {
	return useQuery({
		retry: 0,
		refetchOnWindowFocus: false,
		refetchOnMount: false,
		enabled: false,
		queryKey: ["relationship"],
		queryFn: () => fetchRelationship(eventIdx),
		select: (data) => {
			return data.data;
		},
	});
};
